<section id="calendar-datatable">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div id="header" class="card-header d-flex flex-row justify-content-between">
          <div class="d-flex justify-content-start">
            <button (click)="activateWeekView()" [disabled]="!isMonthMode" class="btn btn-primary header-button-left">
              <span>Semana</span>
            </button>
            <button (click)="activateMonthView()" [disabled]="isMonthMode" class="btn btn-primary header-button-right">
              <span>Mes</span>
            </button>
          </div>
          <h5 id="days-info"
            class="d-flex flex-row align-items-center justify-content-center mb-0 font-weight-bold card-title">
            <span>{{ daysInfo }}</span>
          </h5>
          <div class="d-flex justify-content-start month-change-container"><!--  -->
            <button (click)="getToday()" [disabled]="currentDaysIsLooking" class="btn btn-primary rounded">
              <span>Hoy</span>
            </button>
            <div class="d-flex">
              <div (click)="getPrevDate()" class="btn btn-primary header-button-left">
                <i class="ft-chevron-left"></i>
              </div>
              <div (click)="getNextDate()" class="btn btn-primary header-button-right">
                <i class="ft-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="card-body">
            <fieldset id="header-fieldset" class="form-group d-flex flex-row justify-content-between">
              <label for="select-by-department" class="filters-container">
                <div class="d-flex flex-row select-filters-container">
                  <div *ngIf="limitIsShown" class="d-flex flex-column pr-2">
                    <span>Mostrar</span>
                    <ng-select style="width: 80px;" id="row-limit" [clearable]="false" [(ngModel)]="rowLimit"
                      (ngModelChange)="updateLimit($event)">
                      <ng-option [value]="10">10</ng-option>
                      <ng-option [value]="25">25</ng-option>
                      <ng-option [value]="50">50</ng-option>
                      <ng-option [value]="100">100</ng-option>
                    </ng-select>
                  </div>
                  <div *ngIf="dptosAreShown" class="d-flex flex-column pr-2">
                    <span>Departamento</span>
                    <ng-select style="width: 220px;" id="select-by-department" [clearable]="true" placeholder="Todos"
                      [(ngModel)]="selectedDpto" (ngModelChange)="filterByDpto()">
                      <ng-option *ngFor="let dpto of dptos" [value]="dpto">{{ dpto }}</ng-option>
                    </ng-select>
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="exportButton; context: { currentMonth, currentYear }"></ng-container>
              </label>
              <div class="leyend-container d-flex small font-weight-bold align-items-center justify-content-start">
                <div *ngFor="let leyend of leyends" class="d-flex align-items-center">
                  <div class="leyend badge badge-pill h1 p-2 m-2 border-0" [ngClass]="getLeyendColor(leyend.type)"
                    (click)="filterByLeyend($event, leyend.type)">
                    {{ leyend.text | uppercase }}
                  </div>
                </div>
              </div>
              <app-input-filter (search)="filterByText($event)" [data]="employeesCopy"></app-input-filter>
            </fieldset>
            <ngx-datatable *ngIf="employees" #tableRowDetails class="bootstrap core-bootstrap"
              [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [rowHeight]="50"
              [limit]="rowLimit" [rows]="employees" [scrollbarH]="true" [scrollbarV]="false" [messages]="tableMessages">
              <ngx-datatable-row-detail [rowHeight]="110">
                <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                  <div class="row-details">
                    <ng-container
                      *ngTemplateOutlet="rowDetails; context: { isMobile, row, currentMonth, currentYear }"></ng-container>
                  </div>
                </ng-template>
              </ngx-datatable-row-detail>
              <ngx-datatable-column name="Expandir" [width]="50" [resizeable]="false" [sortable]="false"
                [frozenLeft]="!isMobile" [draggable]="false" [canAutoResize]="false" [cellClass]="'expand-cell'"
                [headerClass]="'name-header'">
                <ng-template let-row="row" let-expanded="expanded" ngx-datatable-header-template>
                  <a href="javascript:void(0)" [class.datatable-icon-right]="!allRowsIsExpanded"
                    [class.datatable-icon-down]="allRowsIsExpanded" title="Expandir/Colapsar todas las filas"
                    (click)="allRowsToggleExpand()">
                  </a>
                </ng-template>
                <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                  <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
                    [class.datatable-icon-down]="expanded" title="Expandir/Colapsar la fila"
                    (click)="rowDetailsToggleExpand(row)">
                  </a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Empleados" [width]="!isMobile ? dynamicEmployeesColumnWidth : 100"
                [frozenLeft]="!isMobile" [cellClass]="'name-cell'" [headerClass]="'name-header'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <ng-container *ngTemplateOutlet="employeesContent; context: { isMobile, row }">
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngFor="let day of days" [name]="day.name" [prop]="day.prop"
                [width]="isMonthMode ? 55 : 110" [headerClass]="'header-class'" [cellClass]="day.class"
                [sortable]="false" [draggable]="false" [canAutoResize]="true" [resizeable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <ng-container
                    *ngTemplateOutlet="tableContent; context: { row, day, currentMonth, currentYear }"></ng-container>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>